<template>
  <div class="apply" :style="{ minHeight: height + 'px' }">
    <div class="top">
      <GroupInfo></GroupInfo>
      <div class="form">
        <FormItem :label="$t('visitor.apply.phone')">
          <Input type="number" v-model="phone" :placeholder="$t('visitor.apply.phone.tips')" />
        </FormItem>

        <FormItem :label="$t('visitor.apply.sms')">
          <Capture v-model="captcha" :phone="phone" />
        </FormItem>
      </div>
    </div>

    <div class="login-tips">
      <span @click="goRegister">{{ $t('login.register.tips') }}</span>
    </div>

    <div class="button">
      <Button color="#00CCBF" @click="submit" block>{{ $t('common.submit') }}</Button>
    </div>
  </div>
</template>

<script>
import { Button, Notify, Toast } from 'vant';
import FormItem from '@/components/formItem.vue';
import Input from '@/components/input.vue';
import Capture from '@/components/capture.vue';
import GroupInfo from '@/components/groupInfo.vue';
import api from '@/services/api';
export default {
  components: {
    FormItem,
    Input,
    Capture,
    Button,
    GroupInfo,
  },
  data() {
    return {
      captcha: '',
      phone: '',
    };
  },
  computed: {
    info() {
      return this.$store.state.auth.baseInfo;
    },
    id() {
      return this.$route.params.id;
    },
    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
    url() {
      return this.$route.path;
    },
    paramsInfo() {
      return this.$route.params.info;
    },
    historyInfo() {
      return window.history.state && window.history.state.info;
    },
  },
  methods: {
    initState() {
      let info = this.paramsInfo || this.historyInfo;
      if (info) {
        this.info = {
          ...this.info,
          ...info,
        };
        window.history.replaceState(
          {
            info: info,
          },
          this.url
        );
      }
    },

    submit() {
      if (!this.auth()) return;
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('empty.loading') + '...',
      });
      api
        .login({
          telephone: this.phone,
          captcha: this.captcha,
          authorId: this.id,
        })
        .then(res => {
          let success = false;
          [success, res] = res;
          Toast.clear();
          if (success) {
            // 后续优化
            sessionStorage.setItem('token', res.data.token);
            sessionStorage.setItem('userInfo', JSON.stringify(res.data));
            this.$store.commit('userUpdate', res.data);
            if (this.historyInfo) {
              if (this.historyInfo.type === 'visitor') {
                return this.$router.push({ name: 'visitorUserReview' });
              } else if (this.historyInfo.type === 'meeting') {
                return this.$router.push({ name: 'meetingBooking' });
              }
            }
            this.$router.push({ name: 'homeModule' });
          }
        });
    },
    auth() {
      if (!this.phone) {
        Notify({
          type: 'warning',
          message: this.$t('visitor.apply.phone.tips'),
        });
        return false;
      }

      if (!this.captcha) {
        Notify({
          type: 'warning',
          message: this.$t('visitor.apply.sms.tips'),
        });
        return false;
      }

      return true;
    },
    goRegister() {
      this.$router.push({ name: 'register' });
    },
  },
  created() {
    this.initState();
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.apply {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .info {
    height: 232px;
    .left {
      height: 100%;
      padding-left: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .logo {
        width: 180px;
        height: 90px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      span {
        font-size: 30px;
        color: #5d6067;
      }
    }
  }
  .form {
    margin-bottom: 160px;
    padding: 0 30px;
    .divider {
      height: 20px;
    }
  }

  .login-tips {
    color: #00ccbf;
    font-size: 28px;
    margin-bottom: 160px;
  }
  .button {
    position: fixed;
    height: 98px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    padding: 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
